import { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import SendIcon from "@mui/icons-material/Send";
import DocumentTransmittalModal from "./DocTransmittalMadal";
import { useDCS } from "../DCSContext";

export default function DocumentListCard({ type }) {
  const [docTransState, setDocTransState] = useState(false);
  const { setCurrentDocsReviewer, selectedDocuments } = useDCS();

  const handleSendDocuments = () => {
    if (selectedDocuments.length === 0) {
      alert("Please select at least one document to send.");
      return;
    }
    console.log("selectedDocuments", selectedDocuments);
    setCurrentDocsReviewer("doc-transmittal");
  };

  const handleDocTransClose = () => {
    setDocTransState(false);
  };
  return (
    <>
      <Card key={7} sx={{ width: "288px" }}>
        <CardContent>
          <Typography fontSize={"12px"} fontWeight={600} component="div">
            Documents Transmittal
          </Typography>
          <Stack
            direction="row"
            paddingTop={1}
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Typography variant="h5">{selectedDocuments.length}</Typography>
            <Stack direction="row" spacing={1}>
              <Button
                sx={{
                  backgroundColor: "#EFC3CA",
                  "&:hover": {
                    backgroundColor: "#EFC3CA",
                  },
                  minWidth: "auto",
                  padding: "8px",
                }}
                onClick={() => {
                  setCurrentDocsReviewer("doc-transmittal");
                }}
                title="Open Document Transmittal"
              >
                <MoveUpIcon sx={{ color: "#5D4108FF" }} />
              </Button>
              <Button
                sx={{
                  backgroundColor: "#4CAF50",
                  "&:hover": {
                    backgroundColor: "#45a049",
                  },
                  minWidth: "auto",
                  padding: "8px",
                }}
                onClick={handleSendDocuments}
                disabled={selectedDocuments.length === 0}
                title="Send Selected Documents"
              >
                <SendIcon sx={{ color: "#FFFFFF" }} />
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
      <DocumentTransmittalModal
        open={docTransState}
        handleClose={handleDocTransClose}
        type={type}
      />
    </>
  );
}
